<template lang="html">
    <div class="audit">

        <PageTitle
            :text="pageTitle">
        </PageTitle>

        <div class="layout-width padding">

            <div style="padding-bottom: 20px">
                <p>{{ pageDescription }}</p>
            </div>

            <div
                class="padding shadow"
                style="padding-top:40px; margin-bottom:20px;">
                <el-form
                    ref="siteForm"
                    :model="form"
                    :rules="rules"
                    label-width="200px">

                    <el-form-item
                        label="Entreprise"
                        prop="facility_name"
                    >
                        <el-input
                            v-model="form.facility_name"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item
                        label="Nom de l'établissement"
                        prop="company_name"
                    >
                        <el-input
                            v-model="form.company_name"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="Client" prop="client_name" v-if="userIsAtLeastManager">
                        <el-input
                            v-model="form.client_name"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item
                        label="Nombre de moteurs à selectionner pour l’audit"
                        prop="motorbox_count"
                        class="audit-number-label"
                    >
                        <el-col :span="10">
                            <el-input-number
                                v-model.number="form.motorbox_count"
                                :min="0"
                                style="width:100%"
                                class="audit-number-input">
                            </el-input-number>
                        </el-col>
                        <el-col :span="2" class="audit-help">
                            <FormHelp text="Nombre maximum de moteurs pouvant être sélectionnés pour cet audit"></FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Ville"
                        prop="location_city"
                    >
                        <el-input
                            v-model="form.location_city"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item
                        label="Code postal"
                        prop="location_zip"
                    >
                        <el-input
                            v-model="form.location_zip"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item
                        label="Adresse"
                        prop="location_street_a"
                    >
                        <el-input
                            v-model="form.location_street_a"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item
                        label="Adresse complémentaire"
                        prop="location_street_b"
                    >
                        <el-input
                            v-model="form.location_street_b"
                            style="width:100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button
                            type="primary"
                            icon="el-icon-check"
                            @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            icon="el-icon-close"
                            @click="$router.go(-1)">
                            Annuler
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/partials/ui/PageTitle';
import FormHelp from '@/components/partials/ui/FormHelp';
import schwartz from 'schwartz';

export default {
    name: 'Motor',
    components: {
        PageTitle,
        FormHelp
    },
    data () {
        return {
            form: {
                facility_name: '',
                company_name: '',
                location_city: '',
                location_zip: '',
                location_street_a: '',
                location_street_b: '',
                client_name: '',
                motorbox_count: 0,
            },
            rules: {
                facility_name: [
                    { required: true, message: 'L\'entreprise est obligatoire', trigger: 'blur' }
                ],
                company_name: [
                    { required: true, message: 'Le nom de l\'établissement est obligatoire', trigger: 'change' }
                ],
                location_street_a: [
                    { required: true, message: 'L\'adresse est obligatoire', trigger: 'change' }
                ],
                location_city: [
                    { required: true, message: 'Le nom de la ville est obligatoire', trigger: 'change' }
                ],
                location_zip: [
                    { required: true, message: 'Le code postal est obligatoire', trigger: 'change' }
                ],
                client_name: [
                    { required: true, message: 'Le client est obligatoire', trigger: 'change' }
                ],
                motorbox_count: [
                    { required: true, message: 'Le nombre de moteurs à selectionner pour l’audit est obligatoire', trigger: 'change' }
                ],
            },
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'user',
            'audit',
            'currentUser',
            'currentSite',
            'userIsAtLeastManager',
        ]),
        userSite () {
            if (!this.currentSite && !this.userIsAtLeastManager){
                this.$router.push({name: 'Home'})
            }
            return this.currentSite
        },
        userAudit() {
            if (this.userSite){
                let audits = this.audit.filter(a => a.site_uid === this.userSite.uid)
                if (audits.length > 0){
                    return audits[0]
                }
            }
        },
        pageTitle () {
            return this.userSite ? this.userSite.facility_name : 'Nouveau site'
        },
        pageDescription () {
             return this.userSite ? `Modifer les informations du ${this.userSite.facility_name}` : 'Créer un nouveau site'
        },
        customers (){
            let availableCustomers = this.user.filter((user) => user.level === 'simpleuser' && this.currentUser !== user.uid);
            return availableCustomers;
        },

    },
    created () {
        if (this.userSite){
            this.form.facility_name = this.userSite.facility_name
            this.form.company_name = this.userSite.company_name
            this.form.location_city = this.userSite.location_city
            this.form.location_zip = this.userSite.location_zip
            this.form.location_street_a = this.userSite.location_street_a
            this.form.location_street_b = this.userSite.location_street_b
            this.form.client_name = this.userSite.client_name
            if (this.userAudit){
                this.form.motorbox_count = this.userAudit.motorbox_count
            }
        }
    },
    methods: {
        save () {
            this.$refs.siteForm.validate( valid => {
                if (valid) {
                    // save in concrete
                    let siteMethod = this.userSite ? 'patchItem' : 'createItem'
                    let auditMethod = this.userAudit ? 'patchItem' : 'createItem'

                    let siteData = {
                        facility_name: this.form.facility_name,
                        company_name: this.form.company_name,
                        location_city: this.form.location_city,
                        location_zip: this.form.location_zip,
                        location_street_a: this.form.location_street_a,
                        location_street_b: this.form.location_street_b,
                        client_name: this.form.client_name,
                    }

                    let auditData = {
                        motorbox_count: this.form.motorbox_count,
                    }

                    const siteItem = this.userSite ? Object.assign({
                        uid: this.userSite.uid,
                        url: this.userSite.url
                    }, siteData) : siteData;

                    const auditItem = this.userAudit ? Object.assign({
                        uid: this.userAudit.uid,
                        url: this.userAudit.url
                    }, auditData) : auditData;

                    if (!this.userSite){
                        siteItem.salesperson_uid = this.currentUser.uid
                    }

                    this.$store.dispatch(siteMethod, {
                        item: siteItem,
                        model: 'site',
                        url: 'site/'
                    // eslint-disable-next-line
                    }).then(res => {
                        let siteUid = res.uid
                        auditItem.site_uid = siteUid
                        this.$store.dispatch(auditMethod, {
                            item: auditItem,
                            model: 'audit',
                            url: 'audit/'
                        // eslint-disable-next-line
                        }).then(res => {
                            this.$notify({
                                title: 'Enregistré',
                                message: 'Site enregistré avec succès',
                                type: 'success'
                            });
                            this.$router.go(-1);
                        })
                    }).catch(err => {
                        // console.log(err);
                        this.$notify({
                            title: 'Erreur',
                            message: err.message,
                            type: 'error'
                        });
                    });
                } else {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Merci de vérifiez que les champs sont bien renseignés',
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style lang="css">
.audit-number-label {
    margin: 0;
    padding: 0;
}
.audit-number-input{
    margin-top:  1em;
}
.audit-help {
    margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Site/index.vue